import { useAppSelector } from 'hooks/useAppSelector';
import {
  ConnectedAddonManagementItem,
  ConnectedPostTradeItem,
  ConnectedPriceImprovementBlotterItem,
  ConnectedScheduledQuotesBlotterItem,
  ConnectedSecondaryPostTradeItem,
} from 'layouts/main/sp-header/navigation/activities-items';
import { Divider } from 'layouts/main/sp-header/navigation/components/divider';
import { DropdownSectionTitle } from 'layouts/main/sp-header/navigation/components/dropdown-section-title';
import { NavigationDropdown } from 'layouts/main/sp-header/navigation/NavigationDropdown';
import { createSelector } from 'reselect';
import type { RoutePath } from 'state/router';
import {
  isAddonManagementVisible,
  isPostTradeVisible,
  isPriceImprovementBlotterVisible,
  isScheduledQuotesBlotterVisible,
  isSecondaryPostEventVisible,
} from 'state/selectors/common/router';

const associatedRoutes: RoutePath[] = [
  '/post-trade',
  '/addon-management',
  '/price-improvement-blotter',
  '/scheduled-quotes-blotter',
  '/secondary-market-post-event-workspace',
];

const isPrimarySectionVisibleSelector = createSelector(
  isPostTradeVisible,
  isAddonManagementVisible,
  isPriceImprovementBlotterVisible,
  isScheduledQuotesBlotterVisible,
  (postTrade, addonManagement, priceImprovement, scheduledQuotes) =>
    postTrade || addonManagement || priceImprovement || scheduledQuotes,
);

const isVisibleSelector = createSelector(
  isPrimarySectionVisibleSelector,
  isSecondaryPostEventVisible,
  (isPrimary, isSecondary) => isPrimary || isSecondary,
);

export function ActivitiesMenu() {
  const isPrimarySectionVisible = useAppSelector(isPrimarySectionVisibleSelector);
  const isSecondarySectionVisible = useAppSelector(isSecondaryPostEventVisible);
  const isVisible = useAppSelector(isVisibleSelector);

  return (
    <NavigationDropdown
      associatedRoutes={associatedRoutes}
      isVisible={isVisible}
      e2e="activities-menu"
      toggleE2e="activities-dropdown-toggle"
      menuE2e="activities-dropdown-menu"
      label="appHeader.navigation.activities"
    >
      {isPrimarySectionVisible && (
        <>
          <DropdownSectionTitle title="primaryMarket" />
          <ConnectedPostTradeItem />
          <ConnectedAddonManagementItem />
          <ConnectedPriceImprovementBlotterItem />
          <ConnectedScheduledQuotesBlotterItem />
        </>
      )}
      {isPrimarySectionVisible && isSecondarySectionVisible && <Divider />}
      {isSecondarySectionVisible && (
        <>
          <DropdownSectionTitle title="secondaryMarket" />
          <ConnectedSecondaryPostTradeItem />
        </>
      )}
    </NavigationDropdown>
  );
}
